import { NgModule } from "@angular/core";
import { CradlepointProvisioningComponent } from "./cradlepoint-provisioning.component";
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { DeviceModule } from "@app/features/device-health/device.module";
import { ErrorsModule } from "@app/features/errors/errors.module";

@NgModule( {
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        DeviceModule,
        ErrorsModule
    ],
    declarations:[
        CradlepointProvisioningComponent
        
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class CradlepointProvisioningModule {}